"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RadioButtonField = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ControlledInputField = _interopRequireDefault(require("../ControlledInputField"));

var defaultProps = {
  labelIsLight: false,
  checked: false,
  inputType: 'checkbox',
  testId: 'cf-ui-radio-button-field'
};

var RadioButtonField = function RadioButtonField(props) {
  var testId = props.testId,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["testId"]);
  return /*#__PURE__*/_react["default"].createElement(_ControlledInputField["default"], (0, _extends2["default"])({
    testId: testId
  }, otherProps, {
    inputType: "radio"
  }));
};

exports.RadioButtonField = RadioButtonField;
RadioButtonField.defaultProps = defaultProps;
var _default = RadioButtonField;
exports["default"] = _default;